export type CsvValue = string | number | boolean | null | undefined;

// RFC 4180 quoting plus spreadsheet formula-injection protection: a cell that
// starts with = + - @ (or tab / CR) gets a leading apostrophe so Excel and
// Sheets treat it as text. Plain numbers such as -12.5 are left alone.
export function csvCell(v: CsvValue): string {
  const s = guardFormula(v === null || v === undefined ? '' : String(v));
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// The formula guard alone, for exports that quote with another writer
// (Papa.unparse): string cells get the apostrophe, everything else passes through.
export function guardFormula<T>(v: T): T | string {
  if (typeof v !== 'string') return v;
  return /^[=+\-@\t\r]/.test(v) && !/^[+-]?(\d+\.?\d*|\.\d+)(e[+-]?\d+)?$/i.test(v) ? `'${v}` : v;
}

export const guardRows = <T,>(rows: T[][]): Array<Array<T | string>> => rows.map((r) => r.map(guardFormula));

export function toCsv(head: string[], rows: CsvValue[][]): string {
  return [head.join(',')].concat(rows.map((r) => r.map(csvCell).join(','))).join('\r\n');
}

export function downloadCsv(filename: string, csv: string) {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
